// Page: TradeSetup.jsx
// Purpose: Placeholder for the retired manual "Trade Setup" page. The legacy
//   Trade Stock.jsx family (TradeActionMenu / TradeOrderSection / TradeSettings)
//   was orphaned + crashing and has been removed. Manual order entry now lives
//   in Smart Trade; this page is a clean "under construction" shell until the
//   surface is rebuilt.

import React from "react";
import { useNavigate } from "react-router-dom";
import { PageHeader, EmptyState, Icon, Button } from "../../components/ds";

const TradeSetup = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-main-bg dark:bg-main-dark-bg pt-0 px-4 md:px-6 pb-10">
      <div className="mb-6">
        <PageHeader title="Trade Setup" subtitle="Manual order entry" />
      </div>

      <EmptyState
        icon={<Icon name="trade" size={40} />}
        title="Under construction"
        description="This page is being rebuilt. Manual trading is available in Smart Trade for now."
        action={
          <Button variant="primary" onClick={() => navigate("/SmartTrade")}>
            Go to Smart Trade
          </Button>
        }
      />
    </div>
  );
};

export default TradeSetup;
